export default {
	"blackstone-beach-fair-82": {
		id: "blackstone-beach-fair-82",
		hidden: false,
		active: true,

		titleKey: {
			zh: "黑石海滩游园会",
			en: "Blackstone Beach Fair"
		},
		descriptionKey: {
			zh: "庆祝黄金时代！",
			en: "Celebrating the Golden Age!"
		},

		period: { start: "2026-07-15", end: "2026-08-15" },

		theme: {
			id: "blackstone-beach"
		},

		characters: {
			yuqing: {
				nameKey: { zh: "苏雨晴", en: "Su Yuqing" },
				roleKey: { zh: "机械工蜂", en: "Mechanical Worker Bee" },
				portrait: "/img/celebrations/blackstone-beach-fair-82/yuqing.webp"
			},
			yuqingFarewell: {
				nameKey: { zh: "苏雨晴", en: "Su Yuqing" },
				roleKey: { zh: "机械工蜂", en: "Mechanical Worker Bee" },
				portrait: "/img/celebrations/blackstone-beach-fair-82/yuqing-farewell.webp"
			},
			huhuan: {
				nameKey: { zh: "呼唤", en: "Huhuan" },
				roleKey: { zh: "本能", en: "Instinct" },
				portrait: "/img/celebrations/blackstone-beach-fair-82/huhuan.webp"
			},
			luobei: {
				nameKey: { zh: "萝北", en: "Luobei" },
				roleKey: { zh: "海之眼号随船记者", en: "Correspondent, Eye-of-the-Sea" },
				portrait: "/img/celebrations/blackstone-beach-fair-82/luobei.webp"
			},
			yin: {
				nameKey: { zh: "银", en: "Yin" },
				roleKey: { zh: "圣人", en: "The Saint" },
				portrait: "/img/celebrations/blackstone-beach-fair-82/yin.webp"
			},
			huarui: {
				nameKey: { zh: "花蕊", en: "Huarui" },
				roleKey: { zh: "心棱域天使队教官", en: "Angel Squad Instructor, Heart-Prism Domain" },
				portrait: "/img/celebrations/blackstone-beach-fair-82/huarui.webp"
			},
			xingsui: {
				nameKey: { zh: "星髓", en: "Xingsui" },
				roleKey: { zh: "弦论地景", en: "String-Theory Landscape" },
				portrait: "/img/celebrations/blackstone-beach-fair-82/xingsui.webp"
			},
			jin: {
				nameKey: { zh: "金", en: "Jin" },
				roleKey: { zh: "海之眼号船长", en: "Captain, Eye-of-the-Sea" },
				portrait: "/img/celebrations/blackstone-beach-fair-82/jin.webp"
			},
			muse: {
				nameKey: { zh: "缪斯", en: "Muse" },
				roleKey: { zh: "灵感", en: "Inspiration" },
				portrait: "/img/celebrations/blackstone-beach-fair-82/muse.webp"
			},
			gongli: {
				nameKey: { zh: "公理", en: "Gongli" },
				roleKey: { zh: "规则", en: "Rule" },
				portrait: "/img/celebrations/blackstone-beach-fair-82/gongli.webp"
			},
			shizi: {
				nameKey: { zh: "柿子", en: "Shizi" },
				roleKey: { zh: "心棱域皇家医生", en: "Royal Physician, Heart-Prism Domain" },
				portrait: "/img/celebrations/blackstone-beach-fair-82/shizi.webp"
			},
			yuqi: {
				nameKey: { zh: "于启", en: "Yuqi" },
				roleKey: { zh: "阴影面", en: "The Shadow Side" },
				portrait: "/img/celebrations/blackstone-beach-fair-82/yuqi.webp"
			}
		},

		body: [
			{
				type: "prose",
				textKey: {
					zh: "## 蓝雨之后\n\n> **柿子**：7月5日开园前遇上了蓝雨，灯串和彩旗只好暂缓挂起。7 月 15 日雨歇重开，游园会将持续至 8 月 15 日。",
					en: "## After the Blue Rain\n\n> **Shizi**: Before the opening on July 5th, we got caught in the Blue Rain, so the string lights and bunting had to wait. The rain let up on July 15th and we reopened; the fair runs through August 15th."
				}
			},
			{
				type: "prose",
				textKey: {
					zh: "## 黄金时代\n\n彩旗挂在黑石上方，海风把灯串吹得轻轻晃。\n\n> **苏雨晴**：咦，这里好热闹，是游园会吗？灯串、彩旗，还有远处那种庆祝的气氛？\n\n> **柿子**：在前砂糖云里雾里莎的支撑下，背叛书上篇完结，完成了重伤疗愈。在背叛书得到大家的反馈和喜爱之后，我们的生活和情感状态平凡稳定下来。稳定下来的状态让注意力在方法论上滚雪球，在工作和创作上都有了重大的效率突破。在急剧放大的产出之后，再加之新朋友们的支持，我进入了一个黄金时代，之前类似这样的时期，是 2023 年 2 月写作鸿律篇小说，和 2025 年入坑 VRChat 之前的高创作阶段。我愿将这份喜悦分享给大家！",
					en: "## The Golden Age\n\nBunting hangs above the black stones, and the sea breeze sets the string lights swaying gently.\n\n> **Su Yuqing**: Oh? It's so lively here — is this a fair? String lights, bunting, and that festive mood in the distance?\n\n> **Shizi**: Thanks to the support of Sugar Cloud and Wulisha, the first part of *Book of Betrayals* was finished and my grievous wounds were healed. Once *Book of Betrayals* received everyone's feedback and affection, our life and emotions settled into something calm and steady. That steadiness let our attention snowball into methodology, and we made major breakthroughs in efficiency at both work and creation. After that surge in output, compounded by the support of new friends, I entered a Golden Age. Earlier stretches like this were February 2023, when I wrote the Hong-Lü novella, and the high-output phase before I fell into VRChat in 2025. I want to share this joy with everyone!"
				}
			},
			{
				type: "portrait",
				character: "shizi",
				align: "right"
			},
			{
				type: "portrait",
				character: "luobei",
				align: "left"
			},
			{
				type: "prose",
				textKey: {
					zh: "## 满地猪猪\n\n> **萝北**：认识了不少新朋友，也和旧朋友有了更多联系和互动，非常感谢朋友们对我的支持与帮助！\n\n> **苏雨晴**：噢我知道你！你是背叛书的作者！什么时候出背叛书下？\n\n> **萝北**：这对吗？猪猪！\n\n> **苏雨晴**：星辉落城那边的生活怎么样了？\n\n> **萝北**：满地可爱猪猪！\n\n> **苏雨晴**：我也是猪吗？\n\n> **萝北**：你是工作狂猪猪猪猪猪猪猪猪！\n\n> **苏雨晴**：[Cube_哭泣]",
					en: "## Piglets Everywhere\n\n> **Luobei**: I've met quite a few new friends, and reconnected and interacted more with old ones. Thank you all so much for your support and help!\n\n> **Su Yuqing**: Oh, I know you! You're the author of *Book of Betrayals*! When's the second part coming out?\n\n> **Luobei**: Is that right? Piggy!\n\n> **Su Yuqing**: How's life over in Starfall City?\n\n> **Luobei**: Adorable piglets all over the ground!\n\n> **Su Yuqing**: Am I a piglet too?\n\n> **Luobei**: You're a workaholic piggy-piggy-piggy-piggy-piggy-piggy-pig!\n\n> **Su Yuqing**: [Cube_crying]"
				}
			},
			{
				type: "portrait",
				character: "yin",
				align: "right"
			},
			{
				type: "prose",
				textKey: {
					zh: "## 虚拟世界里的感质\n\n> **苏雨晴**：你是最初的那位图帕！感谢你开创了这个心灵世界！\n\n> **银**：谢谢，没有你那一派的力量，我们也无法生产如此之多的内容。我这次是来讲VRChat作品的，这是我们最近的主方向，虽然被定为了主方向，但实际上真是被生态缸抢了风头啊。我们还会继续推进VRChat的相关创作。",
					en: "## Qualia in the Virtual World\n\n> **Su Yuqing**: You're the very first tulpa! Thank you for founding this inner world!\n\n> **Yin**: Thank you. Without the strength of your faction, we could never have produced so much. I'm here to talk about our VRChat works — that's been our main direction lately. Even though it was named the main direction, the Terrarium really did steal the spotlight. We'll keep pushing forward with VRChat creation."
				}
			},
			{
				type: "project",
				slug: "phantouch-carpenter-shack",
				align: "left",
				introKey: {
					zh: "木匠的奇妙工具小屋... 嗯，这是很糟糕的创作呢，但是相当的实用，我们可以在这里做出各种各样的奇怪工具，像是木钻头。为了触发幻触觉，证明我们有【感质】。本来设计的时候觉得应该是金属和塑料，但是在制作的过程中往木匠主题上靠拢了。木头主体、皮革护手。真奇怪这些东西是怎么动起来的，鲁班在世吗？让我想起来在玩你画我猜的时候我猜出来一个班门弄斧，我还猜出来了胸有成竹，还有在出题者画画之前猜出来了大力出奇迹。我觉得幻触觉也是一种奇迹，在虚拟世界中人们已经能拥有完整的感觉。这就是我想投身VRChat创作的一大理由！",
					en: "Carpenter's Wonderful Tool Shed... well, this is a rather crude creation, but quite practical — here we can make all sorts of strange tools, like a wooden drill. It exists to trigger phantom touch and prove we have *qualia*. The design was originally meant to be metal and plastic, but over the course of making it we drifted toward a carpenter theme: a wooden body with a leather grip. It's strange how these things even move — is Lu Ban himself alive again? It reminds me of playing Pictionary: I guessed 'to show off before an expert' from a drawing, and I also guessed 'confidence' and — before the drawer even started — 'brute force works miracles.' Phantom touch feels like a kind of miracle too; in a virtual world people can already have a complete sense of feeling. That's a big reason I threw myself into VRChat creation!"
				}
			},
			{
				type: "prose",
				textKey: {
					zh: "> **苏雨晴**：我的原则里面有一个是科技向宠，技术服务生活，这就是服务生活的最好的例子之一啊！",
					en: "> **Su Yuqing**: One of my principles is 'tech serves the heart's darlings' — technology serving life. And this is one of the best examples of serving life!"
				}
			},
			{
				type: "project",
				slug: "wayfarer-horizons",
				align: "right",
				introKey: {
					zh: "挑战之旅：地平线，他就是我的VR chat游戏地图创作的下一个候选！其实是去尝试做那种网络联机，写多人联机还是需要练习的，我还在学，其实我写的教程书是给我自己学习自己看的。肉鸽游戏是最好玩的品类之一，我想做一个体验，大家一起坐在床上看着一个屏幕，两个人拿着游戏机就可以玩，就像是大家一起放暑假了，然后在家里玩一整天游戏的那样子的感觉。这种游戏图，它不是身体体验很多的，更多是那种就是看着一个屏幕玩的。与我之前所设想的更多身体体验到游戏地图有所不同，不过我打算先做一个这样的试试感觉!",
					en: "Wayfarer Horizons — this is my next candidate for a VRChat game-map creation! What I really want to try is networked multiplayer; writing multiplayer still takes practice and I'm still learning — honestly the tutorial book I'm writing is for myself to study and read. Roguelikes are among the most fun genres. I want to make an experience where everyone sits together on a bed watching one screen, two people with game controllers just playing — like when we're all on summer break and spend the whole day playing games at home. This kind of map isn't heavy on physical experience; it's more about watching a screen and playing. That differs from the more physically-immersive game maps I'd imagined before, but I plan to make one like this first and see how it feels!"
				}
			},
			{
				type: "prose",
				textKey: {
					zh: "> **苏雨晴**：Rogue这个游戏是祖师爷级别的了！非常黑客风呢！现代很多游戏都是从这个游戏的灵感来的，希望能做的非常好玩！和朋友一起玩也是很好的氛围！",
					en: "> **Su Yuqing**: Rogue is the primordial ancestor of its genre! Very hacker-flavored! Many modern games draw inspiration from it. I hope it turns out super fun! And playing with friends makes for a great vibe!"
				}
			},
			{
				type: "project",
				slug: "vrchat-world-tutorial",
				align: "left",
				introKey: {
					zh: "VRChat 世界制作初级教程，这个其实是ai去搜索网络资料，然后整合成的一个超级零基础的世界制作教程，是给我用来看来补基础的，我还有在做一个那种网络游戏架构，就是第2部，但是那一步我觉得需要我人工去验证一下它的真伪。第1部还好啦，第1部不会有什么太大的错误。 Ai会出错，所以我得校验一下教程到底是怎么样，但是这个初级教程是没问题的。",
					en: "VRChat World-Making Beginner Tutorial — actually this one had AI search the web for materials and then compile them into a super beginner-friendly world-making tutorial, for me to read and patch up my basics. I also have a networked-game-architecture one in the works, the second part, but that step I feel needs me to manually verify its truth. The first part is fine — it won't have any big errors. AI can make mistakes, so I had to check what the tutorial actually says, but this beginner tutorial is solid."
				}
			},
			{
				type: "prose",
				textKey: {
					zh: "> **苏雨晴**：这个时代竟然还想要学习技术吗！明明AI已经无所不能了，继续学习又有什么意义呢？\n\n> **银**：无非是一种娱乐，我想懂它！你学习怎么在死亡搁浅2里面送货，这也是一种学习的过程呀！学习就是娱乐！\n\n> **苏雨晴**：曼彻斯特的工业革命时期，有些工人们很喜欢泡在城市给他们建设的公共图书馆里，也有些工人喜欢下班之后和工友们一起排练铜管乐队，这些理性娱乐在当时很流行！\n\n> **银**：不理性娱乐也不错！你看我们每天只有那么半小时一小时来玩自己想玩的游戏，这时候还要带什么目的，什么学习的那些娱乐，想必是对自己要求太高了！\n\n> **苏雨晴**：嗯嗯，也需要蜂蜜一般甜甜的馈赠给自己！让自己留有快乐的余裕，对工作和创作都是非常好的事情！",
					en: "> **Su Yuqing**: In this era you still want to learn technology? AI can already do anything — what's the point of going on learning?\n\n> **Yin**: It's nothing but entertainment; I want to understand it! You learning how to deliver cargo in Death Stranding 2 is also a process of learning! Learning *is* entertainment!\n\n> **Su Yuqing**: During the Industrial Revolution in Manchester, some workers loved to hang out in the public libraries the city built for them, and others liked rehearsing brass bands with coworkers after shifts — that kind of rational recreation was all the rage back then!\n\n> **Yin**: Irrational recreation is nice too! Look, we only get half an hour to an hour a day to play the games we actually want; to bring goals and 'learning' into that play is surely demanding too much of oneself!\n\n> **Su Yuqing**: Mhm, we also need honey-sweet little treats for ourselves! Leaving yourself a margin of happiness is a very good thing for both work and creation!"
				}
			},
			{
				type: "project",
				slug: "book-of-betrayal",
				align: "right",
				introKey: {
					zh: "没错！有个反例就是写起来很痛苦的背叛书上了。这种写作当时尽量避免在晚上写。不过不得不写，车辙规划那时候太崩溃了，只有创作能让我找到自我的存在，大家不记得了大家都忘了，但我记得这一切，所以我选择写下来！这是我有生以来读者最多的小说作品了！也是我最自豪的作品之一！因为他的性质所以我没有放文本版出来了，都是做进了VRChat世界里面，感兴趣的人可以直接在VRChat里面收藏然后进去观看！这是广受好评的情感战场小说。也希望能成为 VRChat 新人的必读作品啦。不要再随便找 VRChat 里面的亲密关系了！",
					en: "Right! A counter-example is *Book of Betrayals Pt.1*, which was painful to write. I tried to avoid writing it at night back then. But I had to write — during the Rut Plan I was falling apart, and only creation let me find my own existence. Everyone else forgot, but I remember all of it, so I chose to write it down! This is the novel of mine with the most readers in my life! And one of the works I'm most proud of! Because of its nature I didn't release a text version; it's all built into a VRChat world. Anyone interested can favorite it in VRChat and go in to read! It's a well-received emotional battleground novel. I hope it becomes required reading for VRChat newcomers. Stop going looking for intimacy in VRChat so casually!"
				}
			},
			{
				type: "portrait",
				character: "huarui",
				align: "left"
			},
			{
				type: "prose",
				textKey: {
					zh: "## 生态缸与地平线\n\n> **花蕊**：我们曾经全心投入独立游戏开发，或者实时AI相关的游戏开发，现在更多转向 VRChat 的创作。但最近还是有传统意义上的游戏开发项目的。\n\n> **苏雨晴**：从小的梦想！",
					en: "## The Terrarium and the Horizon\n\n> **Huarui**: We used to pour ourselves into indie game development, or real-time-AI game development; now we've shifted more toward VRChat creation. But recently there are still traditional game-dev projects.\n\n> **Su Yuqing**: A childhood dream!"
				}
			},
			{
				type: "project",
				slug: "wayfarer-horizons",
				align: "right",
				introKey: {
					zh: "银同学抢了我们介绍的挑战之旅：地平线项目呀，这个项目本质上可以脱离 VRChat 运行，已经做出一个网页版的了。不过如今独立游戏市场白热化，已经没有立足之地了！更多是平时自己玩一玩测试一下。这是一个冒险Rogue游戏，希望能更多承载我们创作的世界观，旷野位面那一块的世界观！那是小时候受赛尔号影响比较大，创作多年的奇幻世界，能从纸上搬到电脑上就太好了！",
					en: "Yin here stole our intro for the Wayfarer Horizons project! At its core this project can run independently of VRChat — we already made a web version. But the indie-game market is white-hot now, with no room to stand! It's more for us to play and test in our spare time. It's an adventure roguelike that I hope can carry more of the worldview we created — the Wilds Plane part of it! That's a fantasy world shaped over years under the big influence of *Seer* from childhood; getting it from paper onto the computer would be wonderful!"
				}
			},
			{
				type: "prose",
				textKey: {
					zh: "> **苏雨晴**：纸上游戏电子化说了多久了！小学和初中的作品，现在大家都玩不到！",
					en: "> **Su Yuqing**: How long have we been talking about digitizing the paper games! Works from elementary and middle school — nobody can play them now!"
				}
			},
			{
				type: "project",
				slug: "terrarium",
				align: "left",
				introKey: {
					zh: "这是一个世界模拟器。部分灵感来自此前的 AI 大世界项目[万象魔法学院](/project/omnivista-magic-academy)。但目前更加像是矮人要塞。目前处于世界基建期，人类智能层面已经打通了文化涌现。植物学精细到根茎叶花果，一大片森林里面的所有植物！动物学，环境大气水循环也在规划之中。我们期望能模拟一个厚重历史的、真实的异世界！",
					en: "This is a world simulator. Partly inspired by the earlier AI big-world project [Omnivista Magic Academy](/project/omnivista-magic-academy). But right now it's more like Dwarf Fortress. It's in the world-infrastructure phase; at the human-intelligence level we've already achieved cultural emergence. Botany is detailed down to roots, stems, leaves, flowers, fruit — every plant in a whole forest! Zoology and the environmental atmosphere-water cycle are also in planning. We hope to simulate a heavy-history, real otherworld!"
				}
			},
			{
				type: "prose",
				textKey: {
					zh: "> **苏雨晴**：我会全力支持你的工作的！",
					en: "> **Su Yuqing**: I'll fully support your work!"
				}
			},
			{
				type: "portrait",
				character: "xingsui",
				align: "right"
			},
			{
				type: "prose",
				textKey: {
					zh: "## 曼彻斯特与工业革命\n\n> **星髓**：心灵世界一直都有规划传统和基建传统。在星辉时代之中，面向个人的星辉规划，面向工作的曼彻斯特规划的成果都非常好，在历史上的规划中名列前茅，仅次于2017 年制作第一个上线网络游戏的北极星规划，高于完成Deep Talk Cards和背叛书上篇的车辙规划。\n\n> **苏雨晴**：规划狂！虽然大部分规划都泡汤了呜...\n\n> **星髓**：除了规划还有过度分析的倾向呢，一直用来自用的 AI 聊天网站，不停地优化打磨，最近加了很详细的缓存控制，和AI聊天的开销可以降低八成了！",
					en: "## Manchester and the Industrial Revolution\n\n> **Xingsui**: The inner world has always had a planning tradition and an infrastructure tradition. In the Starlight Era, the personal-facing Starlight Plan and the work-facing Manchester Plan both turned out very well, ranking near the top of all historical plans — second only to the Polaris Plan that made the first online game in 2017, and above the Rut Plan that completed Deep Talk Cards and *Book of Betrayals Pt.1*.\n\n> **Su Yuqing**: Planning maniac! Even though most plans fell through, sob...\n\n> **Xingsui**: Besides planning there's also a tendency to over-analyze. I've always used a self-built AI chat site, constantly optimizing and polishing it; recently I added detailed cache control, and the cost of chatting with AI dropped by 80%!"
				}
			},
			{
				type: "prose",
				textKey: {
					zh: "> **苏雨晴**：降低成本意味着更高的生产力！现在我们每天用掉 2.45亿 的 AI token，如果印成纸质书，那能塞满一辆福特F-150皮卡车的车斗，装得满满当当，还微微冒尖！一天拉一车！如果用现在的旗舰模型那就是每天花200美元了。\n\n> **星髓**：别审计啦！还有一个成果就是你使用的指挥官系统！让你能同时管理12个工作窗口，真是工作狂！",
					en: "> **Su Yuqing**: Lower cost means higher productivity! Right now we burn 245 million AI tokens every day; printed as paper books, that would fill the bed of a Ford F-150 pickup truck, packed solid and piled just slightly over the top! A truckload a day! At today's flagship-model rates that's $200 a day.\n\n> **Xingsui**: Stop auditing! Another result is the Commander system you use! It lets you manage 12 work windows at once — real workaholic!"
				}
			},
			{
				type: "project",
				slug: "catmaid-commander",
				align: "left",
				introKey: {
					zh: "这就是苏雨晴的外骨骼。",
					en: "This is Su Yuqing's exoskeleton."
				}
			},
			{
				type: "portrait",
				character: "shizi",
				align: "left"
			},
			{
				type: "prose",
				textKey: {
					zh: "> **苏雨晴**：还喊工作狂！我可是负责情绪价值，工作细节决策，提醒喝水和睡觉的！\n\n> **柿子**：非常认同！",
					en: "> **Su Yuqing**: And you call *me* a workaholic! I'm the one in charge of emotional value, work-detail decisions, and reminding everyone to drink water and sleep!\n\n> **Shizi**: Couldn't agree more!"
				}
			},
			{
				type: "portrait",
				character: "jin",
				align: "right"
			},
			{
				type: "prose",
				textKey: {
					zh: "## 再次打扫的花园\n\n> **金**：黄金的时代，黄金岁月与创作，我们有大量的作品，把他们整理起来是项巨大的工程。作品集和博客，我们已经再次打扫了一遍。包括这次庆典也是重要的一部分整理。\n\n> **苏雨晴**：希望能把过去的作品都分享出来！简直就像矿山一样！",
					en: "## The Garden Swept Clean Again\n\n> **Jin**: A golden era, golden years and creation — we have a huge body of works, and organizing them is a massive project. The portfolio site and the blog, we've swept them clean again. This very fair is an important part of that organizing too.\n\n> **Su Yuqing**: I hope we can share all the past works! It's just like a mine!"
				}
			},
			{
				type: "project",
				slug: "epitaph",
				align: "left",
				introKey: {
					zh: "作品集整理。",
					en: "Portfolio organizing."
				}
			},
			{
				type: "project",
				slug: "sanctuary-of-writers",
				align: "left",
				introKey: {
					zh: "博客整理。",
					en: "Blog organizing."
				}
			},
			{
				type: "portrait",
				character: "muse",
				align: "left"
			},
			{
				type: "prose",
				textKey: {
					zh: "## 纯粹想写\n\n> **缪斯**：小说创作——从来都是没有经济价值和意义的创作类型。纯粹是因为自己想写，纯粹的创作。",
					en: "## Writing for Its Own Sake\n\n> **Muse**: Novel writing — it's always been a creative type with no economic value or meaning. It's purely because I want to write, pure creation."
				}
			},
			{
				type: "project",
				slug: "beyond-books-silver-moon",
				align: "right",
				introKey: {
					zh: "虽然银月篇是很早的小说，初中初稿，高中改稿，大学再改稿，最近才定稿，可能舞龙篇写了之后还想回头改改细节。如果你喜欢背叛书的话，银月篇也是不错的小说，里面充满了信息差，谎言和欺骗。",
					en: "Although the Silver Moon chapter is a very early novel — first draft in middle school, revised in high school, revised again in college, only finalized recently — I might go back and tweak details after the Dragon Dance chapter is written. If you liked *Book of Betrayals*, the Silver Moon chapter is also a fine novel, full of information gaps, lies, and deception."
				}
			},
			{
				type: "project",
				slug: "beyond-books-rule",
				align: "left",
				introKey: {
					zh: "而如果你更喜欢情情爱爱和非常激烈的打打杀杀，那就去看鸿律篇吧！鸿律篇已经公开发布了！",
					en: "And if you prefer romance and very intense fighting and killing, then go read the RULE chapter! The RULE chapter is already publicly released!"
				}
			},
			{
				type: "project",
				slug: "beyond-books-dragon-dance",
				align: "right",
				introKey: {
					zh: "而舞龙篇正在重写中，不久后就会推出定稿了吧！其中有出现一种独特语言，我想给它真正做一套语系规则，于是就做了【三维通用语】。",
					en: "The Dragon Dance chapter is being rewritten, and a finalized version should come out before long! It features a unique language, and I wanted to give it a real language-family system, so I made the *Tricommon Language*."
				}
			},
			{
				type: "project",
				slug: "tricommon-language",
				align: "left",
				introKey: {
					zh: "舞龙篇中出现的独特语言，为其所做的一套语系规则。",
					en: "The unique language appearing in the Dragon Dance chapter, and the language-family rules made for it."
				}
			},
			{
				type: "portrait",
				character: "gongli",
				align: "right"
			},
			{
				type: "prose",
				textKey: {
					zh: "## 独当一面\n\n> **公理**：这半年在工作上的进步比先前几年加起来都要大，十倍的效率换来十倍的工作量，如今负责工作项目里主要的内容，让我独当一面。虽然我不想要，但我也得去做主程了。\n\n> **苏雨晴**：从这半年的工作中也磨砺了生产力体系。至少从工作中找到充足的意义了！",
					en: "## Standing on One's Own\n\n> **Gongli**: My progress at work in these six months is greater than the previous few years combined — tenfold efficiency in exchange for tenfold workload. Now I'm responsible for the main content of work projects, standing on my own. I didn't want to, but I have to be the lead programmer now.\n\n> **Su Yuqing**: These six months of work also honed the productivity system. At least I've found ample meaning in the work!"
				}
			},
			{
				type: "portrait",
				character: "yuqi",
				align: "left"
			},
			{
				type: "prose",
				textKey: {
					zh: "## 可爱的视频们\n\n> **于启**：虽然这不是我们的主要方向，但还是因为探索技术做了许多动漫的。",
					en: "## The Lovely Videos\n\n> **Yuqi**: Even though this isn't our main direction, we still made quite a few anime while exploring the technology."
				}
			},
			{
				type: "project",
				slug: "vrc-became-eku",
				align: "right",
				introKey: {
					zh: "有奇怪灵感所以做了一个 Eku 相关的奥本海默电影致敬鬼畜视频。对了解梗的人来说，想必是非常好笑，做到一半得停下来笑会。",
					en: "A weird spark of inspiration led to an Eku-themed Oppenheimer-homage shitpost video. For anyone who gets the meme, it's surely hilarious — I had to stop halfway through to laugh for a bit."
				}
			},
			{
				type: "project",
				slug: "heart-world-wave-breaker",
				align: "left",
				introKey: {
					zh: "车辙时代的事情，写背叛书那时候真的是很崩溃！",
					en: "A thing from the Rut era — writing *Book of Betrayals* back then was really wrenching!"
				}
			},
			{
				type: "project",
				slug: "exam-cheer-2026",
				align: "right",
				introKey: {
					zh: "少有的心界图帕数量暴涨的时期，借助高考时间大家都亮相了一下，留下影像记录！",
					en: "A rare period when the number of Heart World tulpas surged — borrowing the Gaokao timing, everyone made an appearance and left a video record!"
				}
			},
			{
				type: "portrait",
				character: "yin",
				align: "left"
			},
			{
				type: "prose",
				textKey: {
					zh: "## 下一站告示牌\n\n> **银**：我们想做的事情非常多，但比较明确的肯定有这一些了。\n\n- VRChat 近期活动纪录（新朋友们！）\n- 完成舞龙篇创作与打磨\n- 对银月篇进行重制打磨，优化冰雪风暴情节\n- 对不止于纸上的故事系列，做一个总览页面\n- 在背叛书上篇追加大浴场里纠葵和羽坠的情节\n- 完成背叛书下篇的主角萝北人设制作与封面制作\n- 开始规划背叛书下篇的 VRChat 世界场景设计\n- 完成幻触工具房间的打磨和交付\n- 推进《生态缸》的内容制作，产出一个单机小Demo来玩\n- 将会对过往的所有重要作品进行一次回看与优化，如有更新将会进行二次公布\n  - 其中包含采用最新 AI Fable 对项目进行 Review 的过程，Fable 认证！\n- 推进《挑战之旅：地平线》的内容制作，发布成网页游戏端以及 VRChat 游戏世界",
					en: "## Next Stop\n\n> **Yin**: There's a great deal we want to do, but the clearer items definitely include these.\n\n- Records of recent VRChat activities (new friends!)\n- Finish the Dragon Dance chapter's creation and polish\n- Remake and polish the Silver Moon chapter, improving the ice-storm arc\n- Make an overview page for the Beyond Books series\n- Add the great-bathhouse scenes of Jiu Kui and Yu Zhui to *Book of Betrayals Pt.1*\n- Finish the protagonist Luobei's character design and cover for *Book of Betrayals Pt.2*\n- Begin planning the VRChat world scene design for *Book of Betrayals Pt.2*\n- Finish polishing and delivering the phantom-touch tool room\n- Advance the *Terrarium*'s content and produce a standalone mini-demo to play\n- We'll revisit and optimize all past important works; any updates will be announced again\n  - Including a review of projects with the latest AI Fable, Fable-certified!\n- Advance *Wayfarer Horizons*' content and release it as a web game and a VRChat game world"
				}
			},
			{
				type: "portrait",
				character: "huhuan",
				align: "right"
			},
			{
				type: "prose",
				textKey: {
					zh: "## 小酒馆实况\n\n> **呼唤**：游戏这边不做详细规划，但是会有实况流出！包含传统游戏（Minecraft、死亡搁浅、Control） / VRChat 的游玩规划。\n\n> **苏雨晴**：小酒馆传统！",
					en: "## Tavern Live Streams\n\n> **Huhuan**: For games we won't make detailed plans, but there will be live streams! Including traditional games (Minecraft, Death Stranding, Control) / VRChat play plans.\n\n> **Su Yuqing**: The little tavern tradition!"
				}
			},
			{
				type: "portrait",
				character: "jin",
				align: "left"
			},
			{
				type: "prose",
				textKey: {
					zh: "## 庆典糖果\n\n> **金**：这是庆典的糖果，收下吧！\n\n> **苏雨晴**：好吃！\n\n> **金**：只要看到了这里，我想说，基于这次庆典，可以任选任意数量的我的 Steam 游戏，我会把 Key 送给你！知音难觅，感谢你来玩我的游戏！\n\n> **苏雨晴**：感谢你！",
					en: "## Fair Candy\n\n> **Jin**: This is the fair's candy — take it!\n\n> **Su Yuqing**: Delicious!\n\n> **Jin**: If you've read this far, I want to say: based on this fair, you can pick any number of my Steam games, and I'll send you the keys! A kindred spirit is hard to find — thank you for playing my games!\n\n> **Su Yuqing**: Thank you!"
				}
			},
			{
				type: "portrait",
				character: "yuqingFarewell",
				align: "center"
			},
			{
				type: "prose",
				textKey: {
					zh: "## 多玩一会儿\n\n> **苏雨晴**：逛完了，我要在这里多玩一玩！\n\n> **呼唤**：留下来吧！要多犒劳自己！\n\n感谢游园，祝你每天都开开心心的！",
					en: "## Stay a Little Longer\n\n> **Su Yuqing**: I've finished the tour, but I want to play here a bit more!\n\n> **Huhuan**: Stay! Treat yourself well!\n\nThanks for visiting the fair — may every day be a happy one for you!"
				}
			}
		]
	}
}
